export const DROPDOWNDATA = [
    {
        key: '2026',
        label: '2026',
        id: 1,
    },
    {
        key: '2025',
        label: '2025',
        id: 2,
    },
    {
        key: '2024',
        label: '2024',
        id: 3,
    },
    {
        key: '2023',
        label: '2023',
        id: 4,
    },
    {
        key: '2022',
        label: '2022',
        id: 5,
    },
    {
        key: '2021',
        label: '2021',
        id: 6,
    },
    {
        key: '2020',
        label: '2020',
        id: 7,
    },
    {
        key: '2019',
        label: '2019',
        id: 8,
    },
    {
        key: '2018',
        label: '2018',
        id: 9,
    },
];
